import { createSelector } from "reselect";

const currentChapter = (state) => state.genericChapters.currentChapter;

export const getCurrentChapterComponents = createSelector(
  [currentChapter],
  (currentChapter) => currentChapter?.components
);

const menuList = (state) => state.menuList;

export const getMenuList = createSelector([menuList], (menuList) => menuList);

export const getCurrentMenu = createSelector([menuList], (menuList) =>
  menuList.find((menu) => menu.current)
);

// New selector to get the current chapter based on the current menu
export const getCurrentChapterFromMenu = createSelector(
  [getCurrentMenu, (state) => state.notebook],
  (currentMenu, notebook) => {
    // Assuming currentMenu has a chapterId property
    return notebook[currentMenu.value]?.components;
  }
);

export const getNextMenuValue = createSelector([menuList], (menuList) =>
  menuList.reduce((nextMenu, menu, index) => {
    if (menu.current) {
      const nextValidMenu = menuList.slice(index + 1).find(
        // Keep only if NOT (locked OR invisible)
        (m) => !(m.locked === true || m.visible === false)
      );

      if (nextValidMenu) {
        nextMenu = nextValidMenu.value;
      }
    }
    return nextMenu;
  }, undefined)
);

export const getPreviousMenuValue = createSelector([menuList], (menuList) =>
  menuList.reduce((prevMenu, menu, index) => {
    if (menu.current) {
      // Look backwards: slice from start to current index, then reverse
      const previousValidMenu = menuList
        .slice(0, index)
        .reverse()
        .find((m) => !(m.locked === true || m.visible === false));

      if (previousValidMenu) {
        prevMenu = previousValidMenu.value;
      }
    }
    return prevMenu;
  }, undefined)
);

const notebook = (state) => state.notebook;

export const getTitle = createSelector(
  [notebook],
  (notebook) => notebook.title
);

export const getSimType = createSelector(
  [notebook],
  (notebook) => notebook.simType
);

export const getProgress = createSelector(
  [notebook],
  (notebook) => notebook.progress
);

export const getMaxProgress = createSelector(
  [notebook],
  (notebook) => notebook.maxProgress
);

export const getCurrentProgress = createSelector(
  [notebook],
  (notebook) => notebook.currentProgress
);

export const getDescription = createSelector(
  [notebook],
  (notebook) => notebook.description
);

const drawerCollapsed = (state) => state.drawerCollapsed;

export const getDrawerCollapsed = createSelector(
  [drawerCollapsed],
  (drawerCollapsed) => drawerCollapsed
);
